<template>
    <body id="app">
        <div class="content">
            <VHeader></VHeader>

            <transition name="fade" mode="out-in">
                <router-view class="view"></router-view>
            </transition>

            <div class="spc4footer"></div>
        </div>

        <VFooter></VFooter>

        <div class="cover"></div>
    </body>
</template>

<script>
    import VHeader from '../components/VHeader.vue';
    import VFooter from '../components/VFooter.vue';

    export default {
        components: {
            'VHeader': VHeader,
            'VFooter': VFooter
        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?4b7a95cf